export class ErrorModel {
  friendlyMessage: string;

  constructor(friendlyMessage: string) {
    this.friendlyMessage = friendlyMessage;
  }
}
